import React from 'react'
import PropTypes from 'prop-types'

import { FlyingCube } from 'Components/Blocks/_Legacy'
import ProjectsSwiper from 'Components/Blocks/_Legacy/ProjectsSwiper'
import { Motion, Wrapper } from 'Components/UI'

import { Container, ContentWrapper } from './styles'

function Projects({ data }) {
  if (!data) return null

  return (
    <Container>
      <Wrapper wayPointTop>
        <Motion>
          <ContentWrapper>
            <ProjectsSwiper data={data} tagTextAs="h4" />
          </ContentWrapper>
        </Motion>
      </Wrapper>

      <FlyingCube
        left={[0, 0, -20, -20, -35, -35, -60]}
        rotateAngle={0}
        size={[0, 0, 105, 105, 160, 160, 210]}
        top={[0, 0, -45, -45, -70, -70, -150]}
      />
    </Container>
  )
}

Projects.propTypes = {
  data: PropTypes.object,
}

export default Projects
